export enum AaeQuestionStatus {
    None,
    Draft,
    NewSubmission,
    AwaitingCustomerInfo,
    InProgress,
    PendingReview,
    AnswerProvided,
    Read,
    ClosedInsufficientInfo,
    OnHold,
    FollowUp,
    Rework,
}

export enum AaeClientQuestionStatus {
    None,
    Draft,
    NewSubmission,
    MoreInfoNeeded,
    OnHold,
    InProgress,
    FollowUp,
    AnswerReady,
    Closed,
}

export enum AaeResponseType {
    User = 1,
    Admin = 2,
    InsufficientInfo = 3,
    ReworkNeeded = 4,
    Feedback = 5,
    FollowUp = 6,
    OnHold = 7,
}

// Same enum as backend values.
export enum AaeBlockReason {
    None = 0,
    ContractEnding = 1,
    InsufficientMinutes = 2,
}
